import { render, staticRenderFns } from "./consultTeacherInfo.vue?vue&type=template&id=e10cf20c"
import script from "./consultTeacherInfo.vue?vue&type=script&lang=js"
export * from "./consultTeacherInfo.vue?vue&type=script&lang=js"
import style0 from "./consultTeacherInfo.vue?vue&type=style&index=0&id=e10cf20c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports